import request from '@/utils/request' //引入封装好的 axios 请求

export function getProductType() { 
  return request({ //使用封装好的 axios 进行网络请求
    url: '/product/getProductType',
    method: 'post',
    data: {
    }

  })
}

export function getProductList() { 
  return request({ //使用封装好的 axios 进行网络请求
    url: '/product/getProductList',
    method: 'post'
  })
}

export function getProductById(productId) { //查询新闻内容
  return request({ //使用封装好的 axios 进行网络请求
    url: '/product/getProductById',
    method: 'post',
    data: {
      productId
    }

  })
}

export function getProductsAndTypes() { //查询新闻内容
  return request({ //使用封装好的 axios 进行网络请求
    url: '/product/getProductsAndTypes',
    method: 'post',
  })
}